import { toast } from 'react-toastify';

import {
  handleTypePricesLink,
  setTypePricesLink,
  setTypePricesLinkErrors,
  clearTypePricesLinkErrors
} from './actions';

import { createTypePricesLink } from './services';

export const registerTypesPricesLink = (userId, establishmentId, clientId, params) => dispatch => {
  dispatch(handleTypePricesLink(true));

  return createTypePricesLink(userId, establishmentId, clientId, params)
    .then(({ data }) => {
      dispatch(clearTypePricesLinkErrors());
      dispatch(setTypePricesLink(data?.typePricesLink));

      toast.success('Vinculo cadastrado com sucesso');

      return Promise.resolve();
    })
    .catch(error => {
      if(!error) {
        dispatch(clearTypePricesLinkErrors());
        toast.error('Houve um erro ao vincular a tabela.');
        return Promise.reject();
      }

      dispatch(setTypePricesLinkErrors(error));

      return Promise.reject(error);
    })
    .finally(() => dispatch(handleTypePricesLink(false)));
}